import { render, staticRenderFns } from "./NeighborhoodsList.vue?vue&type=template&id=8bb424be&scoped=true&"
import script from "./NeighborhoodsList.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodsList.vue?vue&type=script&lang=js&"
import style0 from "./NeighborhoodsList.vue?vue&type=style&index=0&id=8bb424be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb424be",
  null
  
)

export default component.exports